/* import __COLOCATED_TEMPLATE__ from './home-controls.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();